<template>
  <section class="discover">
    <div v-if="$route.name.indexOf('partner') > -1" class="spotlight-title page-container">
      <h2>Discover Partners</h2>
      <button v-if="$route.name === 'partner'" class="btn" @click="$router.push('/partners')">Search All Business Partners</button>
    </div>

    <div v-else-if="artists.find(artist => artist && artist.artwork.length)" class="spotlight-title page-container">
      <h2>Discover Artists</h2>
      <button class="btn" @click="$router.push('/participants')">Search All Artist Profiles</button>
    </div>

    <div v-if="$route.name.indexOf('partner') > -1" class="spotlight">
      <div class="spotlight-item" v-for="partner in partners" :key="partner.id">
        <div class="artist-profile-content">
          <img :src="partner.featured_image.url" :alt="partner.featured_image.alt">
          <button class="artist-title" @click="$router.push(`/partners/${partner.id}`)"><template v-if="partner.tour_number">{{partner.tour_number}}. </template> <template>{{partner.business_name}}</template></button>
          <i v-if="partner.category">{{partner.category.join(', ')}}</i>
        </div>
      </div>
    </div>

    <div v-else-if="artists.find(artist => artist && artist.artwork.length)" class="spotlight">
      <div class="spotlight-item" v-for="artist in artists.filter(artist => artist.artwork.length)" :key="artist.id">
        <button class="spotlight-button" @click="$router.push(`/participants/${artist.id}`)">
          <div class="artist-profile-content">
            <img :src="artist.artwork[0].images[0].image.url" :alt="artist.artwork[0].images[0].image.alt">
            <h3 class="artist-title">{{artist.name}}</h3>
            <i>{{artist.medium}}</i>
          </div>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      partners: [],
      artists: [],
    }
  },
  flickity: {},
  methods: {
    async getRandomPartners() {
      const bpResponse = await fetch(`${this.$root.api_url}getPartners`);
      const partners = await bpResponse.json();

      if (!partners.length) return [];

      let shuffled = partners.slice(0), i = partners.length, min = i - 12, temp, index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      this.partners = shuffled.slice(min);
      setTimeout(this.flickityInit, 100);
    },
    getRandomArtists() {
      if (!this.$root.artists.length) return [];
      let shuffled = this.$root.artists.slice(0), i = this.$root.artists.length, min = i - 12, temp, index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      this.artists = shuffled.slice(min);
      setTimeout(this.flickityInit, 100);
    },
    flickityInit() {
      this.flickity = new Flickity(this.$el.querySelector('.spotlight'), {
        cellAlign: 'center',
        contain: true,
        autoPlay: 10000,
        groupCells: true,
        imagesLoaded: true
      });
      this.flickity.on('dragStart', function(event, pointer) {
        document.ontouchmove = function(e) {
          e.preventDefault();
        }
      });
      this.flickity.on('dragEnd', function(event, pointer) {
        restoreScroll();
      });

      let restoreScroll = () => {
        document.ontouchmove = function(e) {
          return true;
        }
      };
      restoreScroll();
    },
  },
  mounted() {
    if (this.$route.name.indexOf('partner') > -1) {
      this.getRandomPartners();
    } else {
      let checkArtistsInterval = setInterval(() => {
        if (this.$root.artists.length) {
          clearInterval(checkArtistsInterval);
          this.getRandomArtists();
        }
      }, 200);
    }
  },
  activated() {
    if (this.flickity) this.flickity.destroy();
    setTimeout(this.flickityInit, 100);
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.discover {
  padding: 30px 0;
  overflow: hidden;
  background-color: #fff;
  .spotlight-title {
    justify-content: space-between;
    align-items: center;
    @media (min-width: @mobile) {
      display: flex;
    }
    .btn {
      margin: 20px 0;
    }
  }

  .spotlight {
    padding: 35px 70px 45px 70px;
    .spotlight-item {
      width: 25%;
      min-height: 315px;
      margin: 0 15px;
      overflow: hidden;
      text-align: center;
      transform: translateZ(0);
      background-color: #fff;
      @media (max-width: @mobile) {
        width: 100%;
      }
      i {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .spotlight-button {
        max-width: 100%;
      }
    }
  }

  .artist-profile-content {
    padding: 20px;
    text-align: center;
    img {
      display: block;
      max-width: 100%;
      height: 200px;
      margin: 0 auto 20px auto;
      object-fit: cover;
    }
    .artist-title {
      display: block;
      width: 100%;
      overflow: hidden;
      margin: 0 auto 5px 0;
      font-family: @fontSecondary;
      font-size: 25px;
      font-weight: bold;
      white-space: nowrap;
      color: #000;
      text-align: center;
      text-overflow: ellipsis;
      text-decoration: none;
      &:hover {
        color: @themeColor3;
      }
      @media (max-width: @mobile) {
        font-size: 22px;
      }
    }
  }
}
</style>

<style lang="less">
.flickity-page-dots {
  bottom: 0;
  left: 0;
  .dot {
    width: 8px;
    height: 8px;
    opacity: 0.39;
    background: #000;
    &.is-selected {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Discover.vue